<script>
export default {
  name: "AppCard",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    status: {
      type: String,
      default: "base",
      required: false
    }
  },
  mounted() {
    this.$el.classList.add("card", `is-${this.status}`);
  },
  render(createElement) {
    return createElement(this.tag, {}, this.$slots.default);
  }
};
</script>

<style>
.card {
  @apply bg-white shadow-lg border-t-4;
  transition: all 0.2s ease-in-out;
}

.card.is-base,
.card.is-active,
.card.is-open {
  @apply border-primary-500;
}

.card.is-borderless {
  @apply border-none;
}

.card.is-complete,
.card.is-invited,
.card.is-positive {
  @apply border-positive-500;
}

.card.is-incomplete,
.card.is-draft,
.card.is-extended,
.card.is-neutral {
  @apply border-neutral-500;
}

.card.is-rejected,
.card.is-negative {
  @apply border-negative-500;
}

.card.is-disabled,
.card.is-scheduled,
.card.is-passed,
.card.is-closed,
.card.is-grey {
  @apply border-grey-500;
}

a.card {
  @apply text-current no-underline;
}

a.card:hover,
button.card:hover {
  @apply shadow-hover;
  transform: translate3d(0, -0.25rem, 0);
}
</style>
